module.exports = {"140830100":"古魏镇","140830101":"风陵渡镇","140830102":"陌南镇","140830103":"西陌镇","140830104":"永乐镇","140830105":"大王镇","140830106":"阳城镇","140830200":"东垆乡","140830201":"南卫乡","140830202":"学张乡","140830401":"城镇社区管理委员会","140830402":"山西风陵渡经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140830.json
// module id = 343
// module chunks = 0